var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('contratos',{attrs:{"dataServico":_vm.obterDataServicos()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }